import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

export function useAppTabs({ basePath = "", defaultTab = "" }) {
  const params = useParams();
  const navigate = useNavigate();

  const activeTab = params.tab || defaultTab;

  const handleTabChange = useCallback(
    (_e, { name }) => {
      navigate(`${basePath}/${name}`);
    },
    [navigate, basePath]
  );

  return {
    activeTab,
    handleTabChange,
  };
}
